import { z } from 'my-zod'
import { vehicleImage } from './vehicle-use-history-model'
import { vehicleUseHistorySystemView } from './vehicle-use-history-system-view'

export const vehicleUseHistoryOutfitterView = vehicleUseHistorySystemView.augment({
  checkOutVehicleImages: vehicleImage.omit({ imageOrigin: true }).array().nullable(),
  checkInVehicleImages: vehicleImage.omit({ imageOrigin: true }).array().nullable()
})
export type vehicleUseHistoryOutfitterView = z.infer<typeof vehicleUseHistoryOutfitterView>
